import { useEffect } from 'react';

/*
    Who owns the keyboard.

    Escape closed the open message even while an attachment preview was on top
    of it, because both the preview and the mailbox listen on `window` and both
    fired. Ordering them by mount is luck, and `stopImmediatePropagation` from an
    overlay would silence listeners it knows nothing about.

    So overlays say they are open, and the screen underneath asks before acting.
    A counter rather than a flag: two overlays can be stacked, and the one closing
    second must not hand the keyboard back early.

    This is deliberately not React state — it is read inside a keydown handler,
    where what matters is what is true at that instant, not at the last render.
*/

let open = 0;

/** True while anything modal is on screen. */
export const overlayOpen = (): boolean => open > 0;

/** Claims the keyboard for as long as the component is mounted and `active`. */
export function useOverlay(active = true): void {
    useEffect(() => {
        if (!active) return;
        open++;
        return () => {
            open = Math.max(0, open - 1);
        };
    }, [active]);
}
